import PropTypes from "prop-types";
import React from "react";

import { Animated, StyleSheet } from "react-native";
import { connect } from "react-redux";

class Pulse extends React.Component {
  static propTypes = {
    delay: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.value = new Animated.Value(0);
  }

  componentDidMount() {
    const { delay } = this.props;

    Animated.sequence([
      Animated.delay(delay),
      Animated.loop(
        Animated.timing(this.value, {
          duration: 3600,
          toValue: 1,
          useNativeDriver: true
        })
      )
    ]).start();
  }

  render() {
    const { themeColors } = this.props;

    return (
      <Animated.View
        style={[
          styles.pulse,
          {
            backgroundColor: themeColors.lightestPrimary,
            opacity: this.value.interpolate({
              inputRange: [0, 1],
              outputRange: [1, 0]
            }),
            transform: [
              {
                scale: this.value.interpolate({
                  inputRange: [0, 1],
                  outputRange: [1, 3]
                })
              }
            ]
          }
        ]}
      />
    );
  }
}

const styles = StyleSheet.create({
  pulse: {
    borderRadius: 150,
    height: 100,
    position: "absolute",
    width: 100
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(Pulse);
